
import { StyleEntry } from 'Shared/backend/styleUtils';

export function specificPageStyles(sizes,_text): {[name: string]: StyleEntry}
{
	return {
		/*
			Opts a menu into the image-card layout - a poster per item - instead of the default
			imageless list. The menu page and the backend menu editor read this straight off the
			menu document's own 'styles' array (see menuUsesImageCards()), so it carries no css of
			its own; it just has to exist here so the menu designer offers it in the style picker.
		*/
		'Menu image cards': {
			explanation:
				`Lays a menu's items out as image cards - a poster per item - rather than the default
				plain imageless list. Add it to a menu in the menu designer.`,
			rules: [{
				location: () => ['*'],
				css: () => ({})
			}]
		},
		'Contact page top': {
			explanation:
				`Lays out the venue image, hours, and contact details is a space-efficient manner.
				Requires three items in a vertical layout: venue image, then hours, then contact details.`,
			rules: [{
				location: () => ['*'],
				css: () => ({
					['> *:first-child']: {
						width: '100%',
						marginBottom: '1em',

						[`@container (min-width: ${sizes.minDesktopWidth}px)`]: {
							width: '50%',
							float: 'left',
							paddingRight: '2em',
						},
					},
					['> *:nth-child(2)']: {
						width: '100%',
						marginBottom: '1em',

						[`@container (min-width: ${sizes.minDesktopWidth}px)`]: {
							textAlign: 'left'
						},

						[`@container (min-width: ${sizes.flipToMobileNav}px)`]: {
							width: '50%',
							float: 'right'
						},
						h2: {
							marginTop: 0,

							[`@container (min-width: ${sizes.minDesktopWidth}px)`]: {
								/* Trim the empty space from the text so the top aligns with the venue photo */
								marginTop: -12
							}
						}
					},
					['> *:last-child']: {
						width: '100%',

						[`@container (min-width: ${sizes.minDesktopWidth}px)`]: {
							textAlign: 'left'
						},

						[`@container (min-width: ${sizes.flipToMobileNav}px)`]: {
							width: '50%',
							float: 'right'
						},

						margin: '1em 0',
						display: 'flex',
						flexDirection: 'column',
						gap: '1em'
					}
				})
			}]
		},
		'Grid footer': {
			explanation: 'Takes a grid containing footer-style information and formats it with coloured block overlays. Usually used on home pages.',

			rules: [{
				location: () => ['*'],
				css: () => ({
					justifyItems: 'stretch',
					columnGap: 0,
					rowGap: 0,
					textAlign: 'left',

					title: {
						fontSize: '1em',
					},

					'> :nth-child(n)': {
						padding: '20px',
						margin: 0,
					},

					'> :first-child': {
						title: {
							fontSize: '1em',
						},
						borderStyle: 'solid none solid solid',
					},
					'> :nth-child(2)': {
						borderStyle: 'solid none solid none',
					},
					'> :nth-child(3)': {
						borderStyle: 'solid solid solid none',
					},
					'> :nth-child(4)': {
						borderStyle: 'solid solid solid none',
					},
					'> :nth-child(5)': {
						borderStyle: 'none none solid solid',
					},
					'> :nth-child(6)': {
						borderStyle: 'none none solid none',
					},
					'> :nth-child(7)': {
						borderStyle: 'none none solid solid',
					},
					'> :nth-child(8)': {
						borderStyle: 'none solid solid none',
					},

					[`@container (max-width:1000px)`]: {
						//safer to flip to one column sooner
						gridTemplateColumns: '1fr',
						gridTemplateRows: 'repeat(8)',

						'> :first-child': {
							borderStyle: 'solid none none none',
							padding: '20px 0 0 20px',
						},
						'> :nth-child(2)': {
							borderStyle: 'none',
						},
						'> :nth-child(3)': {
							borderStyle: 'none',
						},
						'> :nth-child(4)': {
							borderStyle: 'solid none',
						},
						'> :nth-child(5)': {
							borderStyle: 'none',
						},
						'> :nth-child(6)': {
							borderStyle: 'none',
							padding: '0px 20px 20px 20px',
						},
						'> :nth-child(7)': {
							borderStyle: 'solid none none none',
						},
						'> :nth-child(8)': {
							borderStyle: 'none none solid none',
						},
					},

					[`@container (max-width:${sizes.flipToOneColumn}px)`]: {
						gridTemplateColumns: '1fr',
						gridTemplateRows: 'repeat(8)'
					},
				})
			}]
		},
	};
}

